import ContentGrid from "../../../components/layout/ContentGrid";
import FloatingButtonContainer from "../../../components/layout/FloatingButtonContainer";
import { FloatingActionButton } from "@progress/kendo-react-buttons";
import { AddIcon } from "../../../components/layout/icons/Icons";

export default function PilotageDetailsObservations({ pilotage }) {

    return (
        <>
            <ContentGrid
                title="Observasjoner"
                titleIcon="ship"
                subTitle={`${pilotage.pilotageNo}`}
                canCopySubTitle={true}
            >
            <p>her kommer alle observasjonene....</p>
            </ContentGrid>

            <FloatingButtonContainer hasBottomNavigation={true}>
                <FloatingActionButton
                    themeColor={"primary"}
                    svgIcon={AddIcon}
                    onClick={onAddClick}
                />
            </FloatingButtonContainer>

        </>
    )

    function onAddClick() {
        alert("legg til observasjon");
    }
}
